import React, { useContext, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useParams } from "react-router-dom";
import { Button, Card, Col, Flex, Rate, Row, Select, Table, TableProps, Tag, Typography } from "antd";
import { AuthContext } from "../../../../config/AuthContext";
import JutgeColors from "../../../../styles/JutgeColors";
import { GetJutgeProblemes } from "../../../../dao/jutge/GetJutgeProblemes";
import { ColumnsType } from "antd/es/table";
import { BiArrowFromLeft } from "react-icons/bi";
import { GetAlumneAulesId } from "../../../../dao/abp/GetAlumnesAulesId";
import { GetAlumnesValidacioByProjectV2 } from "../../../../dao/abp/GetAlumnesValidacioByProjectV2";
import { GetUserAules } from "../../../../dao/abp/GetUserAules";
import { FrownOutlined, MehOutlined, SmileOutlined } from "@ant-design/icons";
import AvaluacioColors from "../../../../styles/AvaluacioColors";
import { red } from "@ant-design/colors";
import AppSider from "../../components/AppSider";
import { Content } from "antd/es/layout/layout";
const customIcons: Record<number, React.ReactNode> = {
    1: <FrownOutlined />,
    2: <MehOutlined />,
    3: <SmileOutlined />
};


const Avaluacions = () => {
    const { isLoggedIn, userId, user, setBreadCrumb } = useContext(AuthContext);
    const { id_projecte, id_grup, id_usuari } = useParams();
    const [grup, setGrups] = useState<any[]>([]);
    const [valdacio, setValidacio] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [selectedAlumne, setSelectedAlumne] = useState<any>();
    const [pantalla, setPantalla] = useState(0);
    const [aules, setAules] = useState<any[]>([]);
    const [selectedAula, setSelectedAula] = useState<number | null>(null);

    useEffect(() => {
        if (isLoggedIn) {
            setBreadCrumb([{ nom: 'Home', nav: '/home' },
            { nom: 'avaluacio', nav: '/abp' },
            { nom: 'notes', nav: '/abp/avaluacions' }], true);
            if (user.tipus === "1" || user.tipus === "0") {
                loadAules();
            } else {
                loadSingleUsuari();
            }
        }
    }, [id_projecte]);

    useEffect(() => {
        if (selectedAula) {
            loadStudents(selectedAula);
        }
    }, [selectedAula]);

    async function loadAules() {
        try {
            const data = await GetUserAules(userId);
            setAules(data);
            if (data && data.length > 0) {
                setSelectedAula(data[0].id);
            }
        } catch (error) {
            console.error("Error loading aules", error);
        }
    }

    async function loadStudents(aulaId: number) {
        setLoading(true);
        const data = await GetAlumneAulesId(aulaId.toString());
        setGrups(data);
        // Reset selected student and validation when aula changes
        setSelectedAlumne(undefined);
        setValidacio([]);
        setLoading(false);
    }

    async function loadSingleUsuari() {
        setLoading(true);
        const data = await GetAlumnesValidacioByProjectV2("0", userId, -2);
        const enrichedData = await enrichProjectData(data, userId);
        setValidacio(enrichedData);
        setLoading(false);
    }

    async function loadValidacioData(alumneId: string) {
        setLoading(true);
        setValidacio([])
        if (alumneId !== undefined) {
            const val = await GetAlumnesValidacioByProjectV2("0", alumneId, -2);
            const enrichedData = await enrichProjectData(val, alumneId);
            setValidacio(enrichedData);
        }
        setLoading(false);
    }

    async function enrichProjectData(val: any[], alumneId: string) {
        const allProjects = new Set<number>();
        val.forEach((item: any) => {
            let parsedProjectes = item.projectes;
            if (typeof item.projectes === 'string') {
                try { parsedProjectes = JSON.parse(item.projectes); } catch (e) { parsedProjectes = []; }
            }
            if (Array.isArray(parsedProjectes)) {
                parsedProjectes.forEach((p: any) => allProjects.add(p.id_projecte));
            }
        });

        const { GetProjecteRecuperacions } = await import("../../../../dao/abp/ProjecteRecuperacio");
        const projectDataMap = new Map<number, any[]>();

        for (const projId of Array.from(allProjects)) {
            const recups = await GetProjecteRecuperacions(projId + "");
            const ordData = await GetAlumnesValidacioByProjectV2(projId + "", alumneId, undefined);
            
            const projValidacions: any[] = [];
            projValidacions.push({
                type: 'ordinaria',
                name: 'Ordinària',
                data: ordData,
                tipusCalcul: undefined
            });

            if (recups && recups.length > 0) {
                for (const r of recups) {
                    const rData = await GetAlumnesValidacioByProjectV2(projId + "", alumneId, r.id);
                    projValidacions.push({
                        type: 'recuperacio',
                        name: `Recuperació: ${r.nom}`,
                        data: rData,
                        tipusCalcul: r.tipusCalcul !== undefined ? r.tipusCalcul : r.tipus_calcul
                    });
                }
            }
            projectDataMap.set(projId, projValidacions);
        }

        const processedVal = processData(val);
        
        processedVal.forEach((raItem: any) => {
            const enrichedProjectes: any[] = [];
            
            if (raItem.projectes && Array.isArray(raItem.projectes)) {
                raItem.projectes.forEach((proj: any) => {
                    proj.is_effective = true;
                    proj.display_name = proj.nom_projecte;
                    enrichedProjectes.push(proj);

                    const projEvals = projectDataMap.get(proj.id_projecte) || [];
                    
                    if (projEvals.length > 1) {
                        let isAlreadyApproved = false;

                        projEvals.forEach((evalItem) => {
                            if (evalItem.type === 'recuperacio' && isAlreadyApproved) {
                                return; // Skip showing this recuperation because it was approved previously
                            }

                            const raData = evalItem.data.find((d: any) => d.ra === raItem.ra);
                            if (raData) {
                                // Determine if this specific evaluation approves the RA
                                const notaVal = Number(raData.nota) || 0;
                                if (notaVal >= 5.0) {
                                    isAlreadyApproved = true;
                                }

                                let parsedRubrica = raData.rubrica;
                                if (typeof raData.rubrica === 'string') {
                                    try { parsedRubrica = JSON.parse(raData.rubrica); } catch (e) { parsedRubrica = []; }
                                }
                                enrichedProjectes.push({
                                    ...proj,
                                    id_eval: evalItem.name,
                                    is_effective: false,
                                    display_name: `↳ ${evalItem.name}`,
                                    avaluacio: raData.avaluacio,
                                    nota: raData.nota,
                                    observacions: raData.observacions,
                                    rubrica: parsedRubrica,
                                    tipusCalcul: evalItem.tipusCalcul,
                                    key: `${proj.id_projecte}_${evalItem.name}`
                                });
                            }
                        });
                    }
                });
            }
            raItem.projectes = enrichedProjectes;
        });

        return processedVal;
    }

    const handleAulaChange = (value: number) => {
        setSelectedAula(value);
    };

    const handleAlumneChange = async (alumneId: string) => {
        setSelectedAlumne(alumneId);
        await loadValidacioData(alumneId);
    };

    const calculateFinalGrade = () => {
        const totalWeight = valdacio.reduce((acc, item) => acc + (item.pes || 0), 0);
        if (totalWeight === 0) return "0.00";

        const weightedSum = valdacio.reduce((total, item) => {
            // If not evaluated (avaluacio = 0 or unset), nota is 0
            const hasEval = item.avaluacio !== null && item.avaluacio !== undefined && Number(item.avaluacio) !== 0;
            const nota = hasEval && item.nota !== null && item.nota !== undefined && item.nota !== ""
                ? Number(item.nota)
                : 0;
            const pes = item.pes || 0;
            return total + (nota * pes);
        }, 0);

        return (weightedSum / totalWeight).toFixed(2);
    };

    const processData = (data: any[]) => {
        if (!data || !Array.isArray(data)) return [];
        return data.map((item) => {
            let parsedRubrica = item.rubrica;
            if (typeof item.rubrica === 'string') {
                try {
                    parsedRubrica = JSON.parse(item.rubrica);
                } catch (e) {
                    parsedRubrica = [];
                }
            }

            let parsedProjectes = item.projectes;
            if (typeof item.projectes === 'string') {
                try {
                    parsedProjectes = JSON.parse(item.projectes);
                } catch (e) {
                    parsedProjectes = [];
                }
            }

            // Also ensure rubrica inside each project is parsed!
            if (Array.isArray(parsedProjectes)) {
                parsedProjectes = parsedProjectes.map((p: any) => {
                    let pRub = p.rubrica;
                    if (typeof p.rubrica === 'string') {
                        try {
                            pRub = JSON.parse(p.rubrica);
                        } catch (e) {
                            pRub = [];
                        }
                    }
                    return { ...p, rubrica: pRub };
                });
            }

            return {
                ...item,
                rubrica: parsedRubrica,
                projectes: parsedProjectes,
                key: item.ra ? String(item.ra) : (item.id || `${item.modul}-${Math.random()}`)
            };
        });
    };

    const columnsProfe: ColumnsType<any> = [
        {
            title: 'Mòdul',
            dataIndex: 'modul',
            key: 'modul',
            width: 80,
            render: (text, record, index) => {
                const obj = {
                    children: <Tag color="blue">{text}</Tag>,
                    props: {} as any,
                };
                // Example logic to merge cells could be added here if sorted by Modul
                return obj;
            }
        },
        {
            title: 'RA',
            dataIndex: 'ranom',
            key: 'ranom',
            width: 60,
            render: (text) => <Tag color="purple">{text}</Tag>
        },
        {
            title: 'Tasca / Descripció',
            dataIndex: 'id', // Assuming 'nom' corresponds to the task name/description
            key: 'id',
            render: (text) => <span style={{ fontWeight: 500 }}>{text}</span>
        },
        {
            title: 'Pes (%)',
            dataIndex: 'pes',
            key: 'pes',
            width: 80,
            align: 'right',
            render: (text, record) => {
                const totalWeight = valdacio.reduce((acc, item) => acc + (item.pes || 0), 0);
                const percentage = totalWeight > 0 ? ((record.pes || 0) / totalWeight * 100) : 0;
                return `${Number.isInteger(percentage) ? percentage : percentage.toFixed(2)}%`;
            },
            hidden: user.tipus === "2"
        },
        {
            title: 'Nota',
            dataIndex: 'nota',
            key: 'nota',
            width: 80,
            align: 'center',
            render: (nota, ele) => {
                // If not evaluated (avaluacio = 0 or unset) → show 0
                const hasEval = ele.avaluacio !== null && ele.avaluacio !== undefined && Number(ele.avaluacio) !== 0;
                const n = hasEval && nota !== null && nota !== undefined && nota !== ""
                    ? Number(nota)
                    : 0;
                return (
                    <Tag color={n >= 5.00 ? 'green' : 'red'} style={{ width: '100%', textAlign: 'center', fontSize: '1.1em' }}>
                        {n.toFixed(2)}
                    </Tag>
                );
            },
        },
        {
            title: 'NOTA RA',
            dataIndex: 'nota',
            key: 'nota_ra',
            width: 90,
            align: 'center',
            render: (nota, ele) => {
                const hasEval = ele.avaluacio !== null && ele.avaluacio !== undefined && Number(ele.avaluacio) !== 0;
                const n = hasEval && nota !== null && nota !== undefined && nota !== ""
                    ? Number(nota)
                    : 0;

                const finalVal = n < 5 ? Math.floor(n) : Math.round(n);
                return (
                    <Tag color={finalVal >= 5 ? 'green' : 'red'} style={{ width: '100%', textAlign: 'center', fontSize: '1.2em', fontWeight: 'bold' }}>
                        {finalVal}
                    </Tag>
                );
            }
        },
        {
            title: 'Validació',
            dataIndex: 'avaluacio',
            key: 'avaluacio',
            width: 140,
            align: 'center',
            render: (e, ele) => {
                // avaluacio comes from DB (post_validacio_rubrica computes FLOOR weighted avg for rubrica RAs)
                const escalaValidacio = ele.escala_validacio || 5;
                const val = Number(e) || 0;
                const colorAvg = val <= (escalaValidacio / 3) ? '#f5222d' : (val <= (escalaValidacio * 2 / 3) ? '#faad14' : '#52c41a');

                if (escalaValidacio === 10) {
                    return (
                        <div style={{ fontSize: 16, fontWeight: 'bold', color: colorAvg }}>
                            {val.toFixed(1)} <small style={{ fontSize: 10, opacity: 0.7 }}>/ 10</small>
                        </div>
                    );
                }

                if (escalaValidacio === 3) {
                    const floored = Math.floor(val);
                    let label = "Apte";
                    let col = '#52c41a';
                    if (floored === 2) { label = "Suficient"; col = '#faad14'; }
                    if (floored < 2) { label = "No apte"; col = '#f5222d'; }

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Rate disabled count={3} character={({ index = 0 }) => customIcons[index + 1]} value={floored} style={{ color: col, fontSize: '16px' }} />
                            <Tag color={col} style={{ marginTop: 4 }}>{label}</Tag>
                        </div>
                    );
                }

                return (
                    <Rate disabled count={escalaValidacio} value={Math.round(val * 2) / 2} allowHalf style={{ color: colorAvg, fontSize: '16px' }} />
                );
            },
            hidden: !id_projecte || id_projecte === "0"
        }
    ];

    const rubricExpandedRowRender = (projectRecord: any) => {
        if (!projectRecord.rubrica || projectRecord.rubrica.length === 0) return null;
        return (
            <div style={{ padding: '8px 16px', background: '#f6f8fa', borderRadius: 6, border: '1px solid #f0f0f0' }}>
                <Typography.Text type="secondary" style={{ fontSize: 11, marginBottom: 6, display: 'block', fontWeight: 500 }}>
                    Aspectes a Avaluar per a {projectRecord.nom_projecte}:
                </Typography.Text>
                <Table
                    size="small"
                    pagination={false}
                    dataSource={projectRecord.rubrica}
                    rowKey="id"
                    columns={[
                        {
                            title: 'Aspecte de Rúbrica',
                            dataIndex: 'descripcio',
                            key: 'descripcio',
                        },
                        {
                            title: 'Pes Aspecte (%)',
                            dataIndex: 'pes',
                            key: 'pes',
                            width: 140,
                            align: 'center' as const,
                            render: (e: any, asp: any) => {
                                const totalWeight = projectRecord.rubrica.reduce((acc: number, r: any) => acc + (r.pes || 0), 0);
                                const percentage = totalWeight > 0 ? ((asp.pes || 0) / totalWeight * 100) : 0;
                                return <Tag color="blue">{Number.isInteger(percentage) ? percentage : percentage.toFixed(2)}%</Tag>;
                            }
                        },
                        {
                            title: 'Avaluació',
                            dataIndex: 'avaluacio',
                            key: 'avaluacio',
                            width: 180,
                            align: 'center' as const,
                            render: (e: any, asp: any) => {
                                const aspEscala = asp.escala_validacio || projectRecord.escala_validacio || 5;
                                const effectiveEscala = projectRecord.tipusCalcul === 2 ? 10 : aspEscala;
                                const val = typeof e === 'string' ? parseFloat(e) : (e || 0);
                                const colorAvg = val <= (effectiveEscala / 3) ? '#f5222d' : (val <= (effectiveEscala * 2 / 3) ? '#faad14' : '#52c41a');

                                if (effectiveEscala === 10) {
                                    return (
                                        <div style={{ fontSize: 13, fontWeight: 'bold', color: colorAvg }}>
                                            {val.toFixed(1)} <small style={{ fontSize: 9, opacity: 0.7 }}>/ 10</small>
                                        </div>
                                    );
                                }

                                if (effectiveEscala === 3) {
                                    const floored = Math.floor(val);
                                    let label = "Apte";
                                    let col = '#52c41a';
                                    if (floored === 2) { label = "Suficient"; col = '#faad14'; }
                                    if (floored < 2) { label = "No apte"; col = '#f5222d'; }
                                    return (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, justifyContent: 'center' }}>
                                            <Rate disabled count={3} character={({ index = 0 }) => customIcons[index + 1]} value={floored} style={{ color: col, fontSize: '13px' }} />
                                            <Tag color={col}>{label}</Tag>
                                        </div>
                                    );
                                }

                                return (
                                    <Rate disabled count={effectiveEscala} value={Math.round(val * 2) / 2} allowHalf style={{ color: colorAvg, fontSize: '13px' }} />
                                );
                            }
                        }
                    ]}
                />
            </div>
        );
    };

    const projectColumns = (parentRecord: any) => [
        {
            title: 'Projecte',
            dataIndex: 'nom_projecte',
            key: 'nom_projecte',
            render: (text: string, ele: any) => <span style={{ fontWeight: ele.is_effective ? 600 : 400, color: ele.is_effective ? '#1890ff' : '#595959' }}>{ele.display_name || text}</span>
        },
        {
            title: 'Pes Projecte (%)',
            dataIndex: 'pes_projecte',
            key: 'pes_projecte',
            width: 140,
            align: 'right' as const,
            render: (pes: any, ele: any) => {
                if (ele.is_effective === false) return null;
                return <Tag color="blue">{Number(pes).toFixed(2)}%</Tag>;
            }
        },
        {
            title: 'Nota Projecte',
            dataIndex: 'nota',
            key: 'nota',
            width: 120,
            align: 'center' as const,
            render: (nota: any, ele: any) => {
                const hasEval = ele.avaluacio !== null && ele.avaluacio !== undefined && Number(ele.avaluacio) !== 0;
                const n = hasEval && nota !== null && nota !== undefined && nota !== ""
                    ? Number(nota)
                    : 0;
                return (
                    <Tag color={n >= 5.00 ? 'green' : 'red'} style={{ minWidth: '60px', textAlign: 'center', fontWeight: 'bold' }}>
                        {n.toFixed(2)}
                    </Tag>
                );
            }
        },
        {
            title: 'Validació Projecte',
            dataIndex: 'avaluacio',
            key: 'avaluacio',
            width: 180,
            align: 'center' as const,
            render: (avaluacio: any, ele: any) => {
                const isNotaDirecta = ele.tipusCalcul === 2;
                const escalaValidacio = isNotaDirecta ? 10 : (ele.escala_validacio || 5);
                const val = Number(avaluacio) || 0;
                const colorAvg = val <= (escalaValidacio / 3) ? '#f5222d' : (val <= (escalaValidacio * 2 / 3) ? '#faad14' : '#52c41a');

                if (escalaValidacio === 10) {
                    return (
                        <div style={{ fontSize: 14, fontWeight: 'bold', color: colorAvg }}>
                            {val.toFixed(1)} <small style={{ fontSize: 9, opacity: 0.7 }}>/ 10</small>
                        </div>
                    );
                }

                if (escalaValidacio === 3) {
                    const floored = Math.floor(val);
                    let label = "Apte";
                    let col = '#52c41a';
                    if (floored === 2) { label = "Suficient"; col = '#faad14'; }
                    if (floored < 2) { label = "No apte"; col = '#f5222d'; }

                    return (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, justifyContent: 'center' }}>
                            <Rate disabled count={3} character={({ index = 0 }) => customIcons[index + 1]} value={floored} style={{ color: col, fontSize: '14px' }} />
                            <Tag color={col}>{label}</Tag>
                        </div>
                    );
                }

                return (
                    <Rate disabled count={escalaValidacio} value={Math.round(val * 2) / 2} allowHalf style={{ color: colorAvg, fontSize: '14px' }} />
                );
            }
        }
    ];

    const expandedRowRender = (record: any) => {
        if (!record.projectes || record.projectes.length === 0) return null;
        return (
            <div style={{ padding: '12px 24px', background: '#fafafa', borderRadius: 8, border: '1px dashed #d9d9d9' }}>
                <Typography.Text type="secondary" style={{ fontSize: 12, marginBottom: 8, display: 'block', fontWeight: 600 }}>
                    Detall per Projecte i Rúbrica:
                </Typography.Text>
                <Table
                    size="middle"
                    pagination={false}
                    dataSource={record.projectes}
                    rowKey={(projectRecord) => projectRecord.key || projectRecord.id_projecte}
                    columns={projectColumns(record)}
                    expandable={{
                        expandedRowRender: rubricExpandedRowRender,
                        rowExpandable: (projectRecord) => projectRecord.rubrica && projectRecord.rubrica.length > 0,
                    }}
                />
            </div>
        );
    };

    const tableProps: TableProps<any> = {
        loading
    };

    function setPnt(value: number) {
        setPantalla(value);
    }

    return (
        <>
            <AppSider setPantalla={setPnt} currentVal={2} />
            <Content style={{ padding: '24px', minHeight: 280, background: '#f0f2f5' }}>
                <Card style={{ borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                    <div style={{ marginBottom: 24, borderBottom: '1px solid #f0f0f0', paddingBottom: 16 }}>
                        <h2 style={{ margin: 0, color: '#001529' }}>Avaluació i Validació</h2>
                    </div>

                    {(user.tipus === "0" || user.tipus === "1") && (
                        <Row gutter={16} style={{ marginBottom: 20 }}>
                            <Col span={8}>
                                <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Aula:</label>
                                <Select
                                    style={{ width: '100%' }}
                                    value={selectedAula}
                                    onChange={handleAulaChange}
                                    placeholder="Seleccionar aula"
                                    loading={loading && aules.length === 0}
                                >
                                    {aules.map((aula: any) => (
                                        <Select.Option key={aula.id} value={aula.id}>
                                            {aula.nom}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Col>
                            <Col span={8}>
                                <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Alumne:</label>
                                <Select
                                    style={{ width: '100%' }}
                                    value={selectedAlumne}
                                    onChange={handleAlumneChange}
                                    placeholder="Seleccionar alumne"
                                    disabled={!selectedAula}
                                    showSearch
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {grup?.map((alumne: any) => (
                                        <Select.Option key={alumne.id} value={alumne.id}>
                                            {alumne.nom} {alumne.cognoms}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Col>
                        </Row>
                    )}

                    <Table
                        size="middle"
                        {...tableProps}
                        bordered
                        rowKey={(record) => record.key}
                        pagination={false}
                        columns={columnsProfe.filter(c => !c.hidden)}
                        dataSource={valdacio}
                        expandable={{
                            expandedRowRender,
                            rowExpandable: (record) => record.projectes && record.projectes.length > 0,
                            expandRowByClick: true,
                        }}
                        footer={user.tipus === "2" ? undefined : () => (
                            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 10 }}>
                                <strong>Nota Mitjana de Mòdul:</strong>
                                <Tag color={parseFloat(calculateFinalGrade()) >= 5 ? 'green' : 'red'} style={{ fontSize: 16, padding: '4px 12px' }}>
                                    {calculateFinalGrade()}
                                </Tag>
                            </div>
                        )}
                    />
                </Card>
            </Content>
        </>
    );
};
export default Avaluacions;
